import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Row,
  Form,
  InputGroup,
} from "react-bootstrap";
import Rating from "../../Components/Rating";
import { useDispatch, useSelector } from "react-redux";
import MessageBox from "../../Components/MessageBox";
import LoaderBox from "../../Components/Loader";
import {
  createReview,
  detailsProduct,
} from "../../store/actions/productListActions";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Link, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { PRODUCT_REVIEW_CREATE_RESET } from "../../constants/ProductListConstants";
function ProductScreen(props) {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const params = useParams();
  const { id: productId } = params;

  const [qty, setQty] = useState(1);
  const productDetails = useSelector((state) => state.productDetails);
  const { product, loading, error } = productDetails;

  const addToCartHandler = () => {
    navigate(`/cart/${productId}?qty=${qty}`);
  };

  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const userSignin = useSelector((state) => state.userSignin);
  const { userInfo } = userSignin;

  const productReviewCreate = useSelector((state) => state.productReviewCreate);
  const {
    loading: loadingReviewCreate,
    error: errorReviewCreate,
    success: successReviewCreate,
  } = productReviewCreate;

  useEffect(() => {
    if (successReviewCreate) {
      window.alert("Review Submitted Successfully");
      setRating("");
      setComment("");
      dispatch({ type: PRODUCT_REVIEW_CREATE_RESET });
    }

    dispatch(detailsProduct(productId));
  }, [dispatch, productId, successReviewCreate]);

  const submitHandler = (e) => {
    e.preventDefault();
    if (rating) {
      dispatch(
        createReview(productId, { rating, comment, name: userInfo.name })
      );
    } else {
      alert("Please enter comment and rating");
    }
  };

  return (
    <div className="vh100">
      {loading ? (
        <LoaderBox />
      ) : error ? (
        <MessageBox variant="danger">{error}</MessageBox>
      ) : (
        <>
          <div className="my-5 googleFont_1">
            <Container>
              <Row>
                <Col sm={12} md={4}>
                  <Card style={{ width: "100%" }}>
                    <Card.Img
                      height="500vh"
                      width="100%"
                      variant="top"
                      src={product.image.map((img, i) => img.coverimg)}
                    />
                  </Card>
                </Col>
                <Col sm={6} md={4}>
                  <Card style={{ width: "100%" }} className="border-0">
                    <Card.Body>
                      <Card.Title className="text-danger fs2">
                        {product.name}
                      </Card.Title>
                      <div className="reviewSection">
                        <Rating
                          rating={product.rating}
                          noOfReviews={product.numReviews}
                        ></Rating>
                        <h5>{product.numReviews + " Reviews"}</h5>
                      </div>
                      <div className="price font-weight-bolder">
                        <p>
                          Price:
                          <span className="text-danger">
                            {product.price + " $"}
                          </span>{" "}
                        </p>
                      </div>
                      <div className="desc">
                        <h2>Description:</h2>

                        <p>{product.description}</p>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
                <Col sm={6} md={4}>
                  <Card style={{ width: "100%" }}>
                    <Card.Body>
                      <span className="d-flex justify-content-between font-weight-bolder py-2">
                        <span>Price</span>
                        <span>{product.price + " $"}</span>
                      </span>
                      <span className="d-flex justify-content-between font-weight-bolder py-2">
                        <span>Status</span>
                        {product.countInStock > 0 ? (
                          <span className="text-success">In Stock</span>
                        ) : (
                          <span className="text-danger">Out Of Stock</span>
                        )}
                      </span>
                      {product.countInStock > 0 && (
                        <div className="d-flex justify-content-between align-items-center py-2">
                          <div className="">
                            <Box sx={{ minWidth: 100 }}>
                              <FormControl>
                                <InputLabel id="demo-simple-select-label">
                                  Qty
                                </InputLabel>
                                <Select
                                  value={qty}
                                  onChange={(e) => setQty(e.target.value)}
                                >
                                  {[...Array(product.countInStock).keys()].map(
                                    (x) => (
                                      <MenuItem key={x + 1} value={x + 1}>
                                        {x + 1}
                                      </MenuItem>
                                    )
                                  )}
                                </Select>
                              </FormControl>
                            </Box>
                          </div>
                        </div>
                      )}

                      <Button
                        onClick={addToCartHandler}
                        variant="warning"
                        className="w-100"
                        disabled={product.countInStock === 0 || false}
                      >
                        Add To cart
                      </Button>
                    </Card.Body>
                    {product.countInStock === 0 ? (
                      <Card.Footer
                        style={{
                          border: "none",
                          backgroundColor: "transparent",
                        }}
                      >
                        <Link to="/" className="tdnone">
                          <h5
                            style={{
                              fontSize: "15px",
                              fontStyle: "italic",
                              fontWeight: "bolder",
                            }}
                            className="text-info"
                          >
                            Continue Shopping
                          </h5>
                        </Link>
                      </Card.Footer>
                    ) : null}
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
          <Container className="ratingContainersMain">
            <Row>
              <Col md={{ order: 12 }} xs={{ order: 1 }}>
                <Container className="my-5 ratingMainContainer">
                  {product.reviews.map((review) => (
                    <li key={review._id}>
                      <strong>{review.name}</strong>
                      <Rating rating={review.rating} caption=" "></Rating>
                      <p>{review.createdAt.substring(0, 10)}</p>
                      <p>{review.comment}</p>
                    </li>
                  ))}
                </Container>
              </Col>
              <Col md={{ order: 1 }} xs={{ order: 12 }}>
                <Container className="my-5 ratingMainContainer">
                  <div className="rateHeading">
                    <h1>Rate Product</h1>
                    how do you rated Our product (1 - 5)
                    <div>
                      {product.reviews.length === 0 && (
                        <MessageBox>There is no review</MessageBox>
                      )}
                    </div>
                  </div>

                  <div className="ratingform">
                    {userInfo ? (
                      <Form onSubmit={submitHandler}>
                        <Row className="mb-3">
                          <div key={`inline-radio`} className="mb-3">
                            <Form.Check
                              inline
                              label="1"
                              name="group1"
                              type="radio"
                              id="inline-radio-1"
                              value={1}
                              onChange={(e) => setRating(e.target.value)}
                            />
                            <Form.Check
                              inline
                              label="2"
                              name="group1"
                              type="radio"
                              value={2}
                              onChange={(e) => setRating(e.target.value)}
                              id="inline-radio-2"
                            />
                            <Form.Check
                              inline
                              label="3"
                              name="group1"
                              type="radio"
                              value={3}
                              onChange={(e) => setRating(e.target.value)}
                              id="inline-radio-3"
                            />
                            <Form.Check
                              inline
                              label="4"
                              name="group1"
                              type="radio"
                              value={4}
                              onChange={(e) => setRating(e.target.value)}
                              id="inline-radio-4"
                            />
                            <Form.Check
                              inline
                              label="5"
                              name="group1"
                              type="radio"
                              value={5}
                              onChange={(e) => setRating(e.target.value)}
                              id="inline-radio-5"
                            />
                            <InputGroup className="mt-2">
                              <InputGroup.Text className="bg-dark text-light">
                                Comment
                              </InputGroup.Text>
                              <FormControl
                                className="textAreaLight"
                                as="textarea"
                                aria-label="With textarea"
                                id="comment"
                                value={comment}
                                onChange={(e) => setComment(e.target.value)}
                              />
                            </InputGroup>
                          </div>
                        </Row>

                        <Button
                          type="submit"
                          variant="contained"
                          className="w-90 bg-warning text-dark"
                        >
                          Submit
                        </Button>
                        <div className="mt-2">
                          {loadingReviewCreate && <LoaderBox></LoaderBox>}
                          {errorReviewCreate && (
                            <MessageBox variant="danger">
                              {errorReviewCreate}
                            </MessageBox>
                          )}
                        </div>
                      </Form>
                    ) : (
                      <MessageBox>
                        Please <Link to="/signin">Sign In</Link> to write a
                        review
                      </MessageBox>
                    )}
                  </div>
                </Container>
              </Col>
            </Row>
          </Container>
        </>
      )}
    </div>
  );
}

export default ProductScreen;
